import { RULESET_ORDER } from "../constants";

const getRulesetRank = (rulesetId: number): number => {
  const rank = RULESET_ORDER.indexOf(rulesetId);
  return rank === -1 ? RULESET_ORDER.length : rank;
};

/**
 * Sort comparator for ruleset ids, following RULESET_ORDER. Rulesets not in
 * RULESET_ORDER sort after the listed ones, by id so the order stays stable.
 */
export const compareRulesets = (a: number, b: number): number =>
  getRulesetRank(a) - getRulesetRank(b) || a - b;
